import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { PowtoonAuthProvider } from "@/lib/auth/PowtoonAuthContext";
import { initSentry } from "@/lib/sentry";
import { initAnalytics } from "@/services/analytics";
import { tabId } from "@/lib/frontend-logger";
import { SentryErrorBoundary } from "@/components/SentryErrorBoundary";
import { NavigationBreadcrumbs } from "@/components/NavigationBreadcrumbs";
import App from "./App";
import "./styles.css";
import { registerTavusQueryClient } from "@/lib/scenarios/providers/tavus/faceCache";

initSentry();
initAnalytics();

// Surface the tabId at boot so devs can grab it directly from devtools and
// paste it into Logz.io or Sentry. Every outgoing `x-correlation-id` header
// is prefixed with the first 8 chars of this id.
// eslint-disable-next-line no-console
console.info("[observability]", { tabId, correlationPrefix: tabId.slice(0, 8) });

const queryClient = new QueryClient();
registerTavusQueryClient(queryClient);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <NavigationBreadcrumbs />
          <PowtoonAuthProvider>
            <App />
            <Toaster richColors position="top-right" />
          </PowtoonAuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>
);
